'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$SeedToken(token) {
  this.Kh = null;
  this.Kh = token;
}
export { $c_Lpresto_TwoFactorAuthView$SeedToken as $c_Lpresto_TwoFactorAuthView$SeedToken };
$p = $c_Lpresto_TwoFactorAuthView$SeedToken.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$SeedToken;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$SeedToken() {
}
export { $h_Lpresto_TwoFactorAuthView$SeedToken as $h_Lpresto_TwoFactorAuthView$SeedToken };
$h_Lpresto_TwoFactorAuthView$SeedToken.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_TwoFactorAuthView$SeedToken) && (this.Kh === x$0.Kh)));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "SeedToken";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Kh;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_TwoFactorAuthView$SeedToken(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iX)));
}
export { $isArrayOf_Lpresto_TwoFactorAuthView$SeedToken as $isArrayOf_Lpresto_TwoFactorAuthView$SeedToken };
var $d_Lpresto_TwoFactorAuthView$SeedToken = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$SeedToken, "presto.TwoFactorAuthView$SeedToken", ({
  iX: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_TwoFactorAuthView$SeedToken as $d_Lpresto_TwoFactorAuthView$SeedToken };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$-Seed-Token.js.map
